export default __webpack_public_path__ + "static/pregress tracking@3x-3554d3372f551cd93990202985ba625c.png";